import { Grid, Paper, Typography } from "@material-ui/core";
import React from "react";

const BoxModelDINH = (props) => {
  let {
      ModelID,
      naam,
      FabrikantOmschrijving,
      FabrikantNummer,
      Is_Al_Gekocht,
      PasUitgekomen,
    } = props.data,
    src;
  const { history } = props;

  ModelID = Number(ModelID);

  function borderColor() {
    if (Is_Al_Gekocht === "1") {
      return "green 10px solid";
    } else if (PasUitgekomen === "1") {
      return "orange 10px solid";
    } else {
      return "red 10px solid";
    }
  }

  return (
    <Paper
      elevation={2}
      style={{
        cursor: "pointer",
        border: borderColor(),
      }}
      onClick={() => history.push("/Form/Modellen/Die/Ik/Niet/Heb/" + ModelID)}
    >
      <Grid container justify="space-between">
        <Grid item xs={3}>
          <img
            src={`/media/Model_images_DINH/Model-${ModelID}/${ModelID}-Algemeen_min.jpg`}
            //   + new Date().getTime();
            style={{
              maxWidth: "calc(97% - 8px)",
              marginLeft: 4,
              marginTop: 4,
              borderRadius: 7,
              border: "black 1px solid",
            }}
            alt={"Afbeelding van een Unimog."}
            onError={(e) => {
              e.target.onError = null;
              e.target.src =
                "/media/Model_images/Placeholder.jpg";
            }}
          ></img>
        </Grid>
        <Grid item xs={9} container justify="space-around" alignItems="stretch">
          <Grid item xs={12}>
            <Typography noWrap style={{ fontSize: "120%" }}>
              {naam}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography noWrap style={{ fontSize: "120%" }}>
              {FabrikantOmschrijving}
            </Typography>
          </Grid>
          <Grid item container xs={12}>
            <Grid item xs={8}>
              <Typography noWrap style={{ fontSize: "120%" }}>
                {"art. " + FabrikantNummer}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography noWrap style={{ fontSize: "120%" }}>
                {"DINH " + ModelID}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default BoxModelDINH;
